import { Components, Theme } from '@mui/material';

export const MuiMenu: Components<Omit<Theme, 'components'>>['MuiMenu'] = {
  styleOverrides: {
    paper: ({ theme }) => ({
      backgroundColor: theme.palette.surfaceContainer.high,
      '--Paper-overlay': 'none !important',
    }),

    list: ({ theme }) => ({
      '& .MuiMenuItem-root': {
        backgroundColor: theme.palette.surfaceContainer.high,
        '&:hover': {
          backgroundColor: theme.palette.surfaceContainer.lowest,
        },
        '&.Mui-selected': {
          backgroundColor: theme.palette.surfaceContainer.high,
          '&:hover': {
            backgroundColor: theme.palette.surfaceContainer.lowest,
          },
        },
      },
    }),
  },
};
